import request from "../utils/request";

//展商列表页面
export function getexAll(data) {
  return request({
    url: "/onlineExhibition/exhibitorSearch",
    method: "post",
    data: data,
  });
}
//首页查找展商信息
export function selectHibit(data) {
  return request({
    url: "/onlineExhibition/exhibitorSearch",
    method: "post",
    data: data,
  });
}

// 移动端展商列表
export function mobileExhibits(data) {
  return request({
    url: "/onlineExhibition/exhibitorSearchMobile",
    method: "post",
    data: data,
  });
}
//展商详情

// 展商信息
export function getexhibit(data) {
  return request({
    url: "/onlineExhibition/exhibitorDetails",
    method: "get",
    params: data,
  });
}

// 产品中心的产品
export function getProduct(data) {
  return request({
    url: "/onlineExhibition/getProductCenter",
    method: "get",
    params: data,
  });
}
// 产品中心的产品系列
export function getProSeries(data) {
  return request({
    url: "/onlineExhibition/getProductSeries",
    method: "get",
    params: data,
  });
}

// 直播
export function getLive(data) {
  return request({
    url: "/onlineExhibition/exhibitorLive",
    method: "get",
    params: data,
  });
}

// 活动
export function getActive(data) {
  return request({
    url: "/onlineExhibition/exhibitorActivities",
    method: "get",
    params: data,
  });
}
// 活动产品类型
export function getActiveSeries() {
  return request({
    url: "/onlineExhibition/productType",
    method: "get",
  });
}

// 展商新闻
export function getNews(data) {
  return request({
    url: "/onlineExhibition/exhibitorNews",
    params: data,
    method: "get",
  });
}

// 新闻详情
export function getNewsDetail(data) {
  return request({
    url: "/onlineExhibition/exhibitorNewsInfo",
    params: data,
    method: "get",
  });
}

// 展商资料
export function getFormation(data) {
  return request({
    url: "/onlineExhibition/exhibitorInformation",
    params: data,
    method: "get",
  });
}

// 收藏
export function getShoucang(data) {
  return request({
    url: "/onlineExhibition/addCollect",
    method: "get",
    params: data,
  });
}

// 递名片
export function sendCards(data) {
  return request({
    url: "/onlineExhibition/hzReceiveCard",
    method: "post",
    data: data,
  });
}
